<template>
  <div class="config-page">
    <v-row>
      <v-col cols="12" lg="3" md="3" sm="12" xs="12" class="info-col">
        <v-row class="px-0">
          <InfoCard />
        </v-row>
      </v-col>
      <v-col cols="12" lg="9" md="9" sm="12" xs="12" class="content-col">
        <Selector />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import InfoCard from './templates/Info'
import Selector from './templates/Selector'

import appdata from '@/mixins/appdata'
import utils from '@/mixins/utils'

export default {
  components: { InfoCard, Selector },
  mixins: [ appdata, utils ]
}
</script>

<style src="./styles/index.scss" lang="scss"></style>
